import { render, staticRenderFns } from "./CallPhoneDialog.vue?vue&type=template&id=01445052&scoped=true"
import script from "./CallPhoneDialog.vue?vue&type=script&lang=js"
export * from "./CallPhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./CallPhoneDialog.vue?vue&type=style&index=0&id=01445052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01445052",
  null
  
)

export default component.exports